import { render } from "./PlatMerchantDetail.vue?vue&type=template&id=1c806ded"
import script from "./PlatMerchantDetail.vue?vue&type=script&lang=js"
export * from "./PlatMerchantDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__